import React, { createContext, useState } from "react";

export const DrawerContext = createContext();

export const DrawerContextProvider = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <DrawerContext.Provider value={{ showSidebar, toggleSidebar }}>
      {children}
    </DrawerContext.Provider>
  );
};

// import React, { useState } from "react";
// import { ThemeContext } from "styled-components";

// export const DrawerContext = React.createContext();

// export const DrawerContextProvider = ({ children }) => {
//   const [showSidebar, setShowSidebar] = useState(false);

//   const toggleSidebar = () => {
//     setShowSidebar(!showSidebar);
//   };
//   return (
//     <ThemeContext.Provider isOpen={toggleSidebar}>
//       {children}
//     </ThemeContext.Provider>
//   );
// };
